import styled from "styled-components";
import { colours } from "../../styles/colours.constants";
import { spacing } from "../../styles/styles.constants";

export const Toolbar = styled.nav`
	width: 100%;
	min-height: 67px;
	background-color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	border-bottom: solid 1px ${colours.greyDark};
	padding: 0 ${spacing.padding};
`;
